/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
// @flow
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-danger */

import * as React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';

import { Embed } from 'client/components/common/Embed';
import { analytics } from 'common/utils/ga';

import { addVotedUserInfo, sentEmailInfo } from 'client/actions';

import { COLLECTIONS } from 'client/constants';

import * as css from './Final.scss';

type Props = {|
	className?: string,
	checklistInfo: ChecklistsItem,
	addVotedUserInfo: Function,
	sentEmailInfo: typeof sentEmailInfo,
	emailData: any,
|};

type State = {|
	form: {
		fullName: string,
		phone: string,
		email: string,
		text: string,
		checkbox1: boolean,
		checkbox2: boolean,
	},
	errors: {
		fullNameError: string,
		phoneError: string,
		emailError: string,
		checkbox1Error: string,
		checkbox2Error: string,
	},
	votesSent: boolean,
	formSent: boolean,
|};

class UserForm extends React.PureComponent<Props, State> {
	static defaultProps = {
		className: '',
	};

	state = {
		form: {
			fullName: '',
			phone: '',
			email: '',
			text: '',
			checkbox1: false,
			checkbox2: false,
		},
		errors: {
			fullNameError: '',
			phoneError: '',
			emailError: '',
			checkbox1Error: '',
			checkbox2Error: '',
		},
		votesSent: false,
		formSent: false,
	};

	componentDidMount() {}

	componentDidUpdate(prevProps: Props) {}

	handleInputChange = e => {
		const info = { ...this.state.form, [e.target.name]: e.target.value };
		const errors = {};
		const { error, required } = e.currentTarget.dataset;

		if (e.target.value.length < 1 && required) {
			errors[error] = 'Required';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		} else {
			errors[error] = '';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		}
	};

	handleCheckboxChange = e => {
		const info = { ...this.state.form, [e.target.name]: e.target.checked };
		const errors = {};
		const { error, required } = e.currentTarget.dataset;

		if (!e.target.checked && required) {
			errors[error] = 'Required';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		} else {
			errors[error] = '';
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				form: info,
				errors: errorsInfo,
			});
		}
	};

	onSubmitInfo = async e => {
		e.preventDefault();
		const { checklistInfo } = this.props;
		const { pixelRegistration } = _.get(checklistInfo, 'general', '');

		const { form } = this.state;
		const { fullName, phone, email, text } = form;
		const checkListId = _.get(checklistInfo, 'id', '');
		const {
			fullNameIsRequired,
			phoneIsRequired,
			emailIsRequired,
			formCheckBox1IsRequired,
			formCheckBox2IsRequired,
		} = checklistInfo.form;
		const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const validEmail = emailRegExp.test(form.email.toLocaleLowerCase());
		const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
		const validPhone = phoneRegExp.test(form.phone.toLocaleLowerCase());
		const errors = {};

		if (!form.fullName && fullNameIsRequired) {
			errors.fullNameError = 'שדה חובה';
		}

		if (!form.email && emailIsRequired) {
			errors.emailError = 'שדה חובה';
		}

		if (!form.phone && phoneIsRequired) {
			errors.phoneError = 'שדה חובה';
		}

		if (!form.checkbox1 && formCheckBox1IsRequired) {
			errors.checkbox1Error = 'שדה חובה';
		}

		if (!form.checkbox2 && formCheckBox2IsRequired) {
			errors.checkbox2Error = 'שדה חובה';
		}

		if (form.email && !validEmail) {
			errors.emailError = 'Invalid Email';
		}

		if (form.phone && !validPhone) {
			errors.phoneError = 'Invalid Phone';
		}

		if (_.isEmpty(errors)) {
			const data = {
				collection: COLLECTIONS.USERS,
				data: {
					checkListId,
					fullName: fullName || null,
					phone: phone || null,
					email: email || null,
					message: text || null,
				},
			};
			// if (form.email) {
			// 	const isFiveItemsInEmail = _.get(checklistInfo, 'form.isFiveItemsInEmail', false);
			// 	if (isFiveItemsInEmail) {
			// 		const newEmailsArray = [];
			// 		const shuffleNotSelectedItems = _.shuffle(this.props.emailData.notSelectedIds);
			// 		for (let i = 0; i <= 4; i++) {
			// 			if (shuffleNotSelectedItems[i]) {
			// 				newEmailsArray.push(shuffleNotSelectedItems[i]);
			// 			}
			// 		}

			// 		const response = await this.props.sentEmailInfo({
			// 			collection: COLLECTIONS.GALLERYITEMS,
			// 			data: { ...this.props.emailData, notSelectedIds: newEmailsArray, usersEmail: form.email },
			// 		});

			// 		if (response.result === 'ok') {
			// 			console.info('Email is sent');
			// 		}
			// 	} else {
			// 		const response = await this.props.sentEmailInfo({
			// 			collection: COLLECTIONS.GALLERYITEMS,
			// 			data: { ...this.props.emailData, usersEmail: form.email },
			// 		});
			// 		if (response.result === 'ok') {
			// 			console.info('Email is sent');
			// 		}
			// 	}
			// }

			await this.props.addVotedUserInfo(data);

			if (pixelRegistration) {
				this.setState({ votesSent: true });
			}

			this.setState({
				form: {
					fullName: '',
					phone: '',
					email: '',
					text: '',
					checkbox1: false,
					checkbox2: false,
				},
				errors: {
					fullNameError: '',
					phoneError: '',
					emailError: '',
					checkbox1Error: '',
					checkbox2Error: '',
				},
				formSent: true,
			});
			analytics.gtag.event('Click send form');
		} else {
			const errorsInfo = { ...this.state.errors, ...errors };
			this.setState({
				errors: errorsInfo,
			});
		}
	};

	render() {
		const { checklistInfo } = this.props;
		const { errors, form, formSent } = this.state;
		const { fullName, phone, email, text, checkbox1, checkbox2 } = form;
		const {
			fullNameIsRequired,
			phoneIsRequired,
			emailIsRequired,
			formCheckBox1IsRequired,
			formCheckBox2IsRequired,
		} = checklistInfo.form;
		const { fullNameError, phoneError, emailError, checkbox1Error, checkbox2Error } = errors;
		const isEnableFullName = _.get(checklistInfo, 'form.enableFullName', false);
		const isEnablePhone = _.get(checklistInfo, 'form.enablePhone', false);
		const isEnableMail = _.get(checklistInfo, 'form.enableEmail', false);
		const isEnableText = _.get(checklistInfo, 'form.enableFormText', false);
		const formTextInput = _.get(checklistInfo, 'form.formTextInput', 'הערות');
		const isEnableFormCheckBox1 = _.get(checklistInfo, 'form.enableFormCheckBox1', false);
		const isEnableFormCheckBox2 = _.get(checklistInfo, 'form.enableFormCheckBox2', false);
		const btnColor = _.get(checklistInfo, 'graphics.buttonsTextColor', '#fff');
		const btnBg = _.get(checklistInfo, 'graphics.buttonsBackgroundColor', '#000');
		const successColor = _.get(checklistInfo, 'form.resultsTextsColor', '#000');
		const checkBox1Text = _.get(checklistInfo, 'form.formCheckBox1Text', '');
		const checkBox1Link = _.get(checklistInfo, 'form.formCheckBox1Link', '');
		const checkBox2Text = _.get(checklistInfo, 'form.formCheckBox2Text', '');
		const checkBox2Link = _.get(checklistInfo, 'form.formCheckBox2Link', '');
		const formTitleText = _.get(checklistInfo, 'form.formTitleText', 'טופס הרשמה בתחתית עמוד הסיום:');
		// const textsColor = _.get(checklistInfo, 'graphics.mainSubTitleColor', '#fff');
		const formTextColor = _.get(checklistInfo, 'form.formTextColor', '#fff');
		const embedCode = decodeURIComponent(_.get(checklistInfo, 'general.pixelRegistration', ''));
		const successText = 'הפרטים נשלחו בהצלחה';

		return (
			<div className={css.userForm} style={{ color: formTextColor }}>
				{formSent ? (
					<p className={css.successText} style={{ color: successColor }}>
						{successText}
					</p>
				) : (
					<>
						<h3 className={css.formTitle}>{formTitleText}</h3>
						<div className={css.formWrapper}>
							{isEnableFullName && (
								<div className={css.formRow}>
									<label htmlFor="fullName">שם מלא</label>
									<input
										type="text"
										name="fullName"
										id="fullName"
										placeholder="שם מלא"
										onChange={this.handleInputChange}
										value={fullName}
										data-error="fullNameError"
										data-required={fullNameIsRequired}
									/>
									{fullNameError && <p className={css.error}>{fullNameError}</p>}
								</div>
							)}
							{isEnablePhone && (
								<div className={css.formRow}>
									<label htmlFor="phone">טלפון</label>
									<input
										type="text"
										name="phone"
										id="phone"
										placeholder="050-0000000"
										onChange={this.handleInputChange}
										value={phone}
										data-error="phoneError"
										data-required={phoneIsRequired}
									/>
									{phoneError && <p className={css.error}>{phoneError}</p>}
								</div>
							)}
							{isEnableMail && (
								<div className={css.formRow}>
									<label htmlFor="email">מייל</label>
									<input
										type="text"
										name="email"
										id="email"
										placeholder="example@mail.co.il"
										onChange={this.handleInputChange}
										value={email}
										data-error="emailError"
										data-required={emailIsRequired}
									/>
									{emailError && <p className={css.error}>{emailError}</p>}
								</div>
							)}
							{isEnableText && (
								<div className={css.formRow}>
									<label htmlFor="text">{formTextInput}</label>
									<textarea
										name="text"
										id="text"
										placeholder="כאן כותבים טקסט"
										onChange={this.handleInputChange}
										value={text}
									></textarea>
								</div>
							)}
							{isEnableFormCheckBox1 && (
								<div className={css.formRow}>
									<label className={classNames(css.checkboxRow, checkbox1 && css.active)}>
										<input
											type="checkbox"
											id="checkbox1"
											name="checkbox1"
											value={checkbox1}
											onChange={this.handleCheckboxChange}
											data-error="checkbox1Error"
											data-required={formCheckBox1IsRequired}
										/>
										<div className={css.controll}></div>
										<p>
											{checkBox1Link && (
												<a
													href={checkBox1Link}
													target="_blank"
													rel="noopener noreferrer"
													style={{ color: formTextColor }}
												>
													{checkBox1Text}
												</a>
											)}
											{!checkBox1Link && (
												<span style={{ color: formTextColor }}>{checkBox1Text}</span>
											)}
										</p>
									</label>
									{checkbox1Error && <p className={css.error}>{checkbox1Error}</p>}
								</div>
							)}
							{isEnableFormCheckBox2 && (
								<div className={css.formRow}>
									<label className={classNames(css.checkboxRow, checkbox2 && css.active)}>
										<input
											type="checkbox"
											id="checkbox2"
											name="checkbox2"
											value={checkbox2}
											onChange={this.handleCheckboxChange}
											data-error="checkbox2Error"
											data-required={formCheckBox2IsRequired}
										/>
										<div className={css.controll}></div>
										<p>
											{checkBox2Link && (
												<a
													href={checkBox2Link}
													target="_blank"
													rel="noopener noreferrer"
													style={{ color: formTextColor }}
												>
													{checkBox2Text}
												</a>
											)}
											{!checkBox2Link && (
												<span style={{ color: formTextColor }}>{checkBox2Text}</span>
											)}
										</p>
									</label>
									{checkbox2Error && <p className={css.error}>{checkbox2Error}</p>}
								</div>
							)}
						</div>
						<div className={css.userFormButtonWrapper}>
							<a href="#" style={{ color: btnColor, backgroundColor: btnBg }} onClick={this.onSubmitInfo}>
								שליחה
							</a>
						</div>
					</>
				)}

				{this.state.votesSent && <Embed code={embedCode} />}
			</div>
		);
	}
}

const mapState = (state: ClientStore) => ({});
const mapDispatch = { addVotedUserInfo, sentEmailInfo };

export default connect(mapState, mapDispatch)(UserForm);
